import { useState } from 'react';
import { useAuth } from '../app/Auth';
import { Chip, Empty, ErrorNote, Icon, PageHeader, Segmented, Spinner } from '../app/ui';
import { callFn } from '../lib/api';
import { renderMarkdown } from '../lib/markdown';
import { usePref } from '../lib/persist';
import { useApi } from '../lib/useApi';
import type { Brief } from '../lib/types';

type Kind = 'morning' | 'evening' | 'weekly';

export function BriefPage() {
  const { toast, me } = useAuth();
  const [kind, setKind] = usePref<Kind>('brief.kind', 'morning');
  const q = useApi<{ brief: Brief | null }>('brief_latest', { kind });
  const [building, setBuilding] = useState(false);
  const b = q.data?.brief ?? null;

  async function build() {
    setBuilding(true);
    try { await callFn('brief_run', {}); toast('Brief built', 'ok'); setKind('morning'); await q.reload(true); }
    catch (e) { toast(e instanceof Error ? e.message : String(e), 'err'); }
    finally { setBuilding(false); }
  }

  return (
    <section className="page">
      <PageHeader title="Brief">
        {me && me.role !== 'viewer' ? <button className="btn" disabled={building} onClick={() => void build()}>{building ? 'Building…' : "Build today's"}</button> : null}
        <button className="icon-btn" onClick={() => void q.reload()} aria-label="Refresh"><Icon name="refresh" /></button>
      </PageHeader>
      <Segmented label="Kind" value={kind} onChange={setKind}
        options={[{ id: 'morning', label: 'Morning' }, { id: 'evening', label: 'Evening' }, { id: 'weekly', label: 'Weekly' }]} />
      <ErrorNote text={q.error} />
      {q.loading && !q.data ? <Spinner label="Loading…" /> : null}
      {q.data && !b ? <Empty>No {kind} brief yet. The Assistant writes the first one when its morning job runs.</Empty> : null}
      {b ? (
        <article className="card prose-card">
          <div className="row gap"><Chip>{b.kind ?? kind}</Chip><span className="muted small">{b.forDate ?? ''}</span></div>
          <div className="prose" dangerouslySetInnerHTML={{ __html: renderMarkdown(b.markdown) }} />
        </article>
      ) : null}
    </section>
  );
}
